<template>
    <b-container class="admin-login">
        <b-row class="login-title">
            <b-col>{{$t('admin_login.title')}}</b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-input v-model="username"
                              :placeholder="$t('admin_login.username')"
                              autocomplete="username"
                              @keyup.enter="login">
                </b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
                <b-form-input v-model="password"
                              type="password"
                              :placeholder="$t('login.password')"
                              @keyup.enter="login"
                              autocomplete="current-password">
                </b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3">
                <b-button @click="login" variant="primary" class="login-btn">{{$t('header.login')}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <router-link :to="{name: 'admin-reset-password-init'}" class="forgot-pw-link">{{$t('login.forgot_password')}}</router-link>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'AdminLogin',
        components: {},
        data() {
            return {
                username: '',
                password: '',
            };
        },
        watch: {
            currentUser(newVal, oldVal) {
                if (!oldVal.id && newVal.id) {
                    if (newVal.type == 0) {
                        // this.$showAlertMessage(this.$t('admin_login.not_admin'));
                        this.$storeDispatch('logout');
                    } else {
                        this.$router.replace({name: 'admin'});
                    }
                }
            },
        },
        mounted() {
          this.pageWidth = window.innerWidth;
          this.$nextTick(() => {
            window.addEventListener('resize', () => {
              this.pageWidth = window.innerWidth;
            });
          })
          this.parseNextParams();
        },
        computed: {
            currentUser() {
                return this.$store.state.user;
            },
        },
        methods: {
          parseNextParams() {
            const urlParams = this.$route.query
            const nextUrl = urlParams["next"]
            this.is_oauth = false

            if (nextUrl) {
              const nextParams = new URLSearchParams(
                  new URL(window.location.origin + nextUrl).search
              );
              this.response_type = nextParams.get("response_type") || "";
              this.client_id = nextParams.get("client_id") || "";
              this.redirect_uri = nextParams.get("redirect_uri") || "";
              this.nonce = nextParams.get("nonce") || "";
              this.scope = nextParams.get("scope") || "";
              this.next_url = nextUrl; // Store next URL path
              this.is_oauth = true
            }
          },
          login() {
                if (this.username && this.password) {
                    this.$callAPI("hkiarace/admin/login/", {username: this.username, password: this.password},
                        function () {
                          if (this.is_oauth) {
                            window.location.href = this.next_url.startsWith("/")
                                ? window.location.origin + this.next_url
                                : this.next_url;
                          } else {
                            this.$storeDispatch('adminGetMe');
                          }
                    }, function (response) {
                        if (response.status === 401) {
                            if (response.body.msg === 'locked_account_error') {
                                this.$showAlertMessage(this.$t('login.locked_account_error'));
                            } else if (response.body.msg === 'disabled_account_error') {
                                this.$showAlertMessage(this.$t('login.disabled_account_error'));
                            } else {
                                this.$showAlertMessage(this.$t('login.wrong_password'))
                            }
                        } else {
                            if (typeof response.body === 'object') {
                                if (response.body.verify_email) {
                                    this.$router.push({name: 'email-verify-init'});
                                } else if (response.body.verify_device) {
                                    this.$router.push({name: 'admin-device-verify', query: {after: this.$route.query.after}});
                                } else if ('msg' in response.body) {
                                    this.$showAlertMessage(response.body.msg);
                                } else {
                                    this.$showAlertMessage();
                                }
                            } else {
                                this.$showAlertMessage();
                            }
                        }
                    });

                    this.password = '';
                }
            },
        }
    }
</script>

<style lang="less">
    .admin-login {
        text-align: left;
        padding: 24px;

        .login-title {
            font-weight: bold;
            font-size: 1.3rem;
        }

        .row {
            margin-bottom: 1rem;
        }

        .form-control {
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #ced4da;
        }

        .login-btn {
            width: 100%;
            background-color: #3b3a53;
            border-color: #3b3a53;
            color: white;
            font-weight: bold;
        }

        .forgot-pw-link {
            color: #798188;
        }
    }
</style>